module.exports = __webpack_public_path__ + "static/media/Login image.3c69829e.png";